import { render, staticRenderFns } from "./acts-item.vue?vue&type=template&id=4f85df55"
import script from "./acts-item.vue?vue&type=script&lang=js"
export * from "./acts-item.vue?vue&type=script&lang=js"
import style0 from "./acts-item.vue?vue&type=style&index=0&id=4f85df55&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports